<template>
  <div class="container">
    <div class="about-banner">
      <img src="../../assets/images/banner-6.jpg" />
      <p class="title">{{ t('contactUs.bannertitle') }}</p>
      <!-- <span class="learn-btn">{{ t('learnmore') }}
        <el-icon class="topright-btn" :size="20">
          <TopRight />
        </el-icon>
      </span> -->
    </div>
    <div class="navigation-bar">
      <div class="navigation-bar-txt">
        <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
        <span>{{ t('menu.contactUs') }}</span>
      </div>
    </div>
    <div class="new-list-bar">
      <h2 class="title">{{ t('contactUs.companyname') }}</h2>
      <ul class="contact-list">
        <li v-for="item in coreList" :key="item">
          <span class="span-icon-box"><img :src="item.qrcode" /></span>
          <span class="span-name">{{ item.name }}</span>
          <span class="span-details">{{ item.details }}</span>
        </li>
      </ul>
    </div>
    <div class="new-list-bar" style="margin-bottom: 20px;">
      <h2 class="title">{{ t('contactUs.messtitle') }}</h2>
      <p class="subtitle" style="text-align: left;">{{ t('contactUs.messSubtitle') }}</p>
      <el-form :model="form" label-position="top">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item :label="t('contactUs.moduleA.username')">
              <el-input v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item :label="t('contactUs.moduleA.email')">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="t('contactUs.moduleA.area')">
              <el-select v-model="form.area" placeholder="Select">
                <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item :label="t('contactUs.moduleA.phone')">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="t('contactUs.moduleA.type')">
          <el-select v-model="form.type" placeholder="Select">
            <el-option v-for="item in typeOptions" :key="item.value" :label="String(item.label)" :value="item.value" />
          </el-select>
          <!-- <el-input v-model="form.type"></el-input> -->
        </el-form-item>
        <el-form-item :label="t('contactUs.moduleA.message')">
          <el-input type="textarea" :rows=4 v-model="form.message"></el-input>
        </el-form-item>
        <el-form-item>
          <span class="submit-btn">
            <span>{{ t('submit') }}</span>
            <el-icon class="topright-btn" :size="20">
              <TopRight />
            </el-icon>
          </span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, computed } from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
// const coreListCn = ref([
//   {
//     name: 'Address',
//     details: 'Room 821, Xinhua Science and Technology Mansion, No.8, Tuofangying South Road, Chaoyang District Beijing 100016, China',
//     qrcode: require("../../assets/address.svg"),
//   },
//   {
//     name: 'E-mail',
//     details: 'jennifer@ciabj.com',
//     qrcode: require("../../assets/email.svg"),
//   },
//   {
//     name: 'Call us on',
//     details: '86 10 85790344',
//     qrcode: require("../../assets/phone.svg"),
//   }
// {
//   name: 'WhatsAPP',
//   details: '+0086 1085790344',
//   qrcode: require("../../assets/phone.svg"),
// },
// {
//   name: 'Facebook',
//   details: '+86 10 85790344',
//   qrcode: require("../../assets/phone.svg"),
// },
// {
//   name: 'YouTube',
//   details: '+86 10 85790344',
//   qrcode: require("../../assets/phone.svg"),
// }
// ])
const typeOptions = computed(() => [
  {
    value: "0",
    label: t('coreproductchildmenu.Rotarymilkingmachine'),
  },
  {
    value: "1",
    label: t('coreproductchildmenu.Fully')
  }, {
    value: "2",
    label: t('coreproductchildmenu.Intelligent')
  }, {
    value: "3",
    label: t('coreproductchildmenu.temporary')
  }, {
    value: "4",
    label: t('servicechildmenu.service1')
  },
  {
    value: "5",
    label: t('servicechildmenu.service2')
  }, {
    value: "6",
    label: t('servicechildmenu.service3')
  }, {
    value: "7",
    label: t('servicechildmenu.service4')
  },
  {
    value: "8",
    label: t('coreproductchildmenu.other')
  }
])
const options = [
  {
    label: '亚洲 Asia',
    options: [
      { value: 'CN', label: '中国 China' },
      { value: 'HK', label: '中国香港 Hong Kong SAR' },
      { value: 'MO', label: '中国澳门 Macao SAR' },
      { value: 'TW', label: '中国台湾 Taiwan, China' },
      { value: 'AF', label: '阿富汗 Afghanistan' },
      { value: 'AM', label: '亚美尼亚 Armenia' },
      { value: 'AZ', label: '阿塞拜疆 Azerbaijan' },
      { value: 'BH', label: '巴林 Bahrain' },
      { value: 'BD', label: '孟加拉国 Bangladesh' },
      { value: 'BN', label: '文莱 Brunei' },
      { value: 'BT', label: '不丹 Bhutan' },
      { value: 'KH', label: '柬埔寨 Cambodia' },
      { value: 'KP', label: '朝鲜 DPR Korea' },
      { value: 'KR', label: '韩国 Republic of Korea' },
      { value: 'TL', label: '东帝汶 Timor-Leste' },
      { value: 'EG', label: '埃及 Egypt' },
      { value: 'GE', label: '格鲁吉亚 Georgia' },
      { value: 'IN', label: '印度 India' },
      { value: 'ID', label: '印度尼西亚 Indonesia' },
      { value: 'IR', label: '伊朗 Iran' },
      { value: 'IQ', label: '伊拉克 Iraq' },
      { value: 'IL', label: '以色列 Israel' },
      { value: 'JP', label: '日本 Japan' },
      { value: 'JO', label: '约旦 Jordan' },
      { value: 'KZ', label: '哈萨克斯坦 Kazakhstan' },
      { value: 'KW', label: '科威特 Kuwait' },
      { value: 'KG', label: '吉尔吉斯斯坦 Kyrgyzstan' },
      { value: 'LA', label: '老挝 Laos' },
      { value: 'LB', label: '黎巴嫩 Lebanon' },
      { value: 'MY', label: '马来西亚 Malaysia' },
      { value: 'MV', label: '马尔代夫 Maldives' },
      { value: 'MN', label: '蒙古 Mongolia' },
      { value: 'MM', label: '缅甸 Myanmar' },
      { value: 'NP', label: '尼泊尔 Nepal' },
      { value: 'OM', label: '阿曼 Oman' },
      { value: 'PK', label: '巴基斯坦 Pakistan' },
      { value: 'PH', label: '菲律宾 Philippines' },
      { value: 'QA', label: '卡塔尔 Qatar' },
      { value: 'SA', label: '沙特阿拉伯 Saudi Arabia' },
      { value: 'SG', label: '新加坡 Singapore' },
      { value: 'LK', label: '斯里兰卡 Sri Lanka' },
      { value: 'SY', label: '叙利亚 Syria' },
      { value: 'TJ', label: '塔吉克斯坦 Tajikistan' },
      { value: 'TH', label: '泰国 Thailand' },
      { value: 'TR', label: '土耳其 Turkey' },
      { value: 'TM', label: '土库曼斯坦 Turkmenistan' },
      { value: 'AE', label: '阿联酋 United Arab Emirates' },
      { value: 'UZ', label: '乌兹别克斯坦 Uzbekistan' },
      { value: 'VN', label: '越南 Vietnam' },
      { value: 'YE', label: '也门 Yemen' }
    ]
  },
  {
    label: '欧洲 Europe',
    options: [
      { value: 'AL', label: '阿尔巴尼亚 Albania' },
      { value: 'AD', label: '安道尔 Andorra' },
      { value: 'AT', label: '奥地利 Austria' },
      { value: 'BY', label: '白俄罗斯 Belarus' },
      { value: 'BE', label: '比利时 Belgium' },
      { value: 'BA', label: '波黑 Bosnia and Herzegovina' },
      { value: 'BG', label: '保加利亚 Bulgaria' },
      { value: 'HR', label: '克罗地亚 Croatia' },
      { value: 'CY', label: '塞浦路斯 Cyprus' },
      { value: 'CZ', label: '捷克 Czech Republic' },
      { value: 'DK', label: '丹麦 Denmark' },
      { value: 'EE', label: '爱沙尼亚 Estonia' },
      { value: 'FI', label: '芬兰 Finland' },
      { value: 'FR', label: '法国 France' },
      { value: 'DE', label: '德国 Germany' },
      { value: 'GR', label: '希腊 Greece' },
      { value: 'HU', label: '匈牙利 Hungary' },
      { value: 'IS', label: '冰岛 Iceland' },
      { value: 'IE', label: '爱尔兰 Ireland' },
      { value: 'IT', label: '意大利 Italy' },
      { value: 'LV', label: '拉脱维亚 Latvia' },
      { value: 'LI', label: '列支敦士登 Liechtenstein' },
      { value: 'LT', label: '立陶宛 Lithuania' },
      { value: 'LU', label: '卢森堡 Luxembourg' },
      { value: 'MT', label: '马耳他 Malta' },
      { value: 'MD', label: '摩尔多瓦 Moldova' },
      { value: 'MC', label: '摩纳哥 Monaco' },
      { value: 'ME', label: '黑山 Montenegro' },
      { value: 'NL', label: '荷兰 Netherlands' },
      { value: 'NO', label: '挪威 Norway' },
      { value: 'PL', label: '波兰 Poland' },
      { value: 'PT', label: '葡萄牙 Portugal' },
      { value: 'RO', label: '罗马尼亚 Romania' },
      { value: 'RU', label: '俄罗斯 Russia' },
      { value: 'SM', label: '圣马力诺 San Marino' },
      { value: 'RS', label: '塞尔维亚 Serbia' },
      { value: 'SK', label: '斯洛伐克 Slovakia' },
      { value: 'SI', label: '斯洛文尼亚 Slovenia' },
      { value: 'ES', label: '西班牙 Spain' },
      { value: 'SE', label: '瑞典 Sweden' },
      { value: 'CH', label: '瑞士 Switzerland' },
      { value: 'UA', label: '乌克兰 Ukraine' },
      { value: 'GB', label: '英国 United Kingdom' },
      { value: 'VA', label: '梵蒂冈 Vatican' }
    ]
  },
  {
    label: '非洲 Africa',
    options: [
      { value: 'DZ', label: '阿尔及利亚 Algeria' },
      { value: 'AO', label: '安哥拉 Angola' },
      { value: 'BJ', label: '贝宁 Benin' },
      { value: 'BW', label: '博茨瓦纳 Botswana' },
      { value: 'BF', label: '布基纳法索 Burkina Faso' },
      { value: 'BI', label: '布隆迪 Burundi' },
      { value: 'CV', label: '佛得角 Cape Verde' },
      { value: 'CM', label: '喀麦隆 Cameroon' },
      { value: 'CF', label: '中非 Central African Republic' },
      { value: 'TD', label: '乍得 Chad' },
      { value: 'KM', label: '科摩罗 Comoros' },
      { value: 'CG', label: '刚果（布）Congo-Brazzaville' },
      { value: 'CD', label: '刚果（金）Congo-Kinshasa' },
      { value: 'CI', label: '科特迪瓦 Ivory Coast' },
      { value: 'DJ', label: '吉布提 Djibouti' },
      { value: 'ER', label: '厄立特里亚 Eritrea' },
      { value: 'ET', label: '埃塞俄比亚 Ethiopia' },
      { value: 'GA', label: '加蓬 Gabon' },
      { value: 'GM', label: '冈比亚 Gambia' },
      { value: 'GH', label: '加纳 Ghana' },
      { value: 'GN', label: '几内亚 Guinea' },
      { value: 'GW', label: '几内亚比绍 Guinea-Bissau' },
      { value: 'KE', label: '肯尼亚 Kenya' },
      { value: 'LS', label: '莱索托 Lesotho' },
      { value: 'LR', label: '利比里亚 Liberia' },
      { value: 'LY', label: '利比亚 Libya' },
      { value: 'MG', label: '马达加斯加 Madagascar' },
      { value: 'MW', label: '马拉维 Malawi' },
      { value: 'ML', label: '马里 Mali' },
      { value: 'MR', label: '毛里塔尼亚 Mauritania' },
      { value: 'MU', label: '毛里求斯 Mauritius' },
      { value: 'MA', label: '摩洛哥 Morocco' },
      { value: 'MZ', label: '莫桑比克 Mozambique' },
      { value: 'NA', label: '纳米比亚 Namibia' },
      { value: 'NE', label: '尼日尔 Niger' },
      { value: 'NG', label: '尼日利亚 Nigeria' },
      { value: 'RW', label: '卢旺达 Rwanda' },
      { value: 'ST', label: '圣多美和普林西比 São Tomé and Príncipe' },
      { value: 'SN', label: '塞内加尔 Senegal' },
      { value: 'SC', label: '塞舌尔 Seychelles' },
      { value: 'SL', label: '塞拉利昂 Sierra Leone' },
      { value: 'SO', label: '索马里 Somalia' },
      { value: 'ZA', label: '南非 South Africa' },
      { value: 'SS', label: '南苏丹 South Sudan' },
      { value: 'SD', label: '苏丹 Sudan' },
      { value: 'SZ', label: '斯威士兰 Eswatini' },
      { value: 'TZ', label: '坦桑尼亚 Tanzania' },
      { value: 'TG', label: '多哥 Togo' },
      { value: 'TN', label: '突尼斯 Tunisia' },
      { value: 'UG', label: '乌干达 Uganda' },
      { value: 'ZM', label: '赞比亚 Zambia' },
      { value: 'ZW', label: '津巴布韦 Zimbabwe' }
    ]
  },
  {
    label: '北美洲 North America',
    options: [
      { value: 'AG', label: '安提瓜和巴布达 Antigua and Barbuda' },
      { value: 'BS', label: '巴哈马 Bahamas' },
      { value: 'BB', label: '巴巴多斯 Barbados' },
      { value: 'BZ', label: '伯利兹 Belize' },
      { value: 'CA', label: '加拿大 Canada' },
      { value: 'CR', label: '哥斯达黎加 Costa Rica' },
      { value: 'CU', label: '古巴 Cuba' },
      { value: 'DM', label: '多米尼克 Dominica' },
      { value: 'DO', label: '多米尼加 Dominican Republic' },
      { value: 'SV', label: '萨尔瓦多 El Salvador' },
      { value: 'GD', label: '格林纳达 Grenada' },
      { value: 'GT', label: '危地马拉 Guatemala' },
      { value: 'HT', label: '海地 Haiti' },
      { value: 'HN', label: '洪都拉斯 Honduras' },
      { value: 'JM', label: '牙买加 Jamaica' },
      { value: 'MX', label: '墨西哥 Mexico' },
      { value: 'NI', label: '尼加拉瓜 Nicaragua' },
      { value: 'PA', label: '巴拿马 Panama' },
      { value: 'KN', label: '圣基茨和尼维斯 Saint Kitts and Nevis' },
      { value: 'LC', label: '圣卢西亚 Saint Lucia' },
      { value: 'VC', label: '圣文森特和格林尼丁斯 Saint Vincent and the Grenadines' },
      { value: 'TT', label: '特立尼达和多巴哥 Trinidad and Tobago' },
      { value: 'US', label: '美国 United States' }
    ]
  },
  {
    label: '南美洲 South America',
    options: [
      { value: 'AR', label: '阿根廷 Argentina' },
      { value: 'BO', label: '玻利维亚 Bolivia' },
      { value: 'BR', label: '巴西 Brazil' },
      { value: 'CL', label: '智利 Chile' },
      { value: 'CO', label: '哥伦比亚 Colombia' },
      { value: 'EC', label: '厄瓜多尔 Ecuador' },
      { value: 'GY', label: '圭亚那 Guyana' },
      { value: 'PY', label: '巴拉圭 Paraguay' },
      { value: 'PE', label: '秘鲁 Peru' },
      { value: 'SR', label: '苏里南 Suriname' },
      { value: 'UY', label: '乌拉圭 Uruguay' },
      { value: 'VE', label: '委内瑞拉 Venezuela' }
    ]
  },
  {
    label: '大洋洲 Oceania',
    options: [
      { value: 'AU', label: '澳大利亚 Australia' },
      { value: 'FJ', label: '斐济 Fiji' },
      { value: 'KI', label: '基里巴斯 Kiribati' },
      { value: 'MH', label: '马绍尔群岛 Marshall Islands' },
      { value: 'FM', label: '密克罗尼西亚 Micronesia' },
      { value: 'NR', label: '瑙鲁 Nauru' },
      { value: 'NZ', label: '新西兰 New Zealand' },
      { value: 'PW', label: '帕劳 Palau' },
      { value: 'PG', label: '巴布亚新几内亚 Papua New Guinea' },
      { value: 'WS', label: '萨摩亚 Samoa' },
      { value: 'SB', label: '所罗门群岛 Solomon Islands' },
      { value: 'TO', label: '汤加 Tonga' },
      { value: 'TV', label: '图瓦卢 Tuvalu' },
      { value: 'VU', label: '瓦努阿图 Vanuatu' }
    ]
  }
];
// const coreListZh = ref([
//   {
//     name: '地址',
//     details: '北京市朝阳区驼房营南路8号 \n 新华科技大厦821室',
//     qrcode: require("../../assets/address.svg"),
//   },
//   {
//     name: '电子邮件',
//     details: 'jennifer@ciabj.com',
//     qrcode: require("../../assets/email.svg"),
//   },
//   {
//     name: '总机',
//     details: '0086 1085790344',
//     qrcode: require("../../assets/phone.svg"),
//   }
// {
//   name: '挤奶机销售',
//   details: '+86 10 85790344',
//   qrcode: require("../../assets/phone.svg"),
// },
// {
//   name: '配件销售',
//   details: '+86 10 85790344',
//   qrcode: require("../../assets/phone.svg"),
// },
// {
//   name: '售后服务',
//   details: '+86 10 85790344',
//   qrcode: require("../../assets/phone.svg"),
// }
// ])
const coreList = computed(() => [
  {
    name: t('contactus.name.name1'),
    details: t('contactus.details.name1'),
    qrcode: require("../../assets/address.svg"),
  },
  {
    name: t('contactus.name.name2'),
    details: t('contactus.details.name2'),
    qrcode: require("../../assets/email.svg"),
  },
  {
    name: t('contactus.name.name3'),
    details: t('contactus.details.name3'),
    qrcode: require("../../assets/phone.svg"),
  }
])
watch(locale, (newValue) => {
  if (newValue === 'en') {
    // coreList.value = coreListCn.value
  } else if (newValue === 'zh') {
    // coreList.value = coreListZh.value
  }
}, { immediate: true })
const form = ref({})

</script>
<style lang="scss" scoped>
.about-box {
  margin: 0 auto;
  width: 1280px;
}

.about-banner {
  width: 100%;
  position: relative;

  img {
    display: block;
    width: 100%;
  }

  p {
    width: 1024px;
    position: absolute;
    text-align: center;
    left: 50%;
    margin-left: -521px;
    color: #fff;
  }

  .title {
    top: 180px;
    font-size: 40px;
    font-weight:600;
    letter-spacing:1px;
  }

  .learn-btn {
    cursor: pointer;
    top: 360px;
    height: 46px;
    font-size: 20px;
    line-height: 46px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    text-align: center;
    left: 50%;
    border: 1px solid #fff;
    margin-left: -85px;
    color: #fff;
    border-radius: vars.$radius-4;

    &:hover {
      background-color: vars.$base-color;
      color: #fff;
      border: 1px solid vars.$base-color;
    }

    .topright-btn {
      float: left;
      margin-top: 13px;
    }
  }
}

.new-list-bar {
  padding-top: 30px;

  .contact-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;

    li {
      padding-top: 100px;
      display: flex;
      flex-direction: column;
      width: 420px;
      height: 240px;
      border-radius: 8px;
      background: #F6F6F6;
      text-align: center;

      span {
        display: block;
      }

      .span-icon-box {
        margin: 0 auto;
        width: 100px;
        height: 100px;
        border-radius: 15px;
        border: 1px solid vars.$base-color;

        img {
          margin-top: 30px;
          width: 40px;
        }
      }

      .span-name {
        margin-top: 16px;
        font-size: 20px;
      }

      .span-details {
        width: 410px;
        margin: 16px auto 0px;
        font-size: 16px;
      }
    }

  }
}

.label-on-top .el-form-item__label {
  display: block;
  float: none;
  padding-bottom: 6px;
}

.label-on-top .el-form-item__content {
  margin-left: 0 !important;
}

.submit-btn {
  cursor: pointer;
  margin-top: 20px;
  padding: 0 20px;
  height: 46px;
  font-size: 16px;
  line-height: 46px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  color: #fff;
  background-color: vars.$base-color;
  border-radius: vars.$radius-4;

  .topright-btn {
    margin-top: 13px;
  }
}
</style>